import React, { useState } from "react";
import store from "@/redux/store";
import { Link, useNavigate } from "react-router-dom";
import { EyeIcon } from '@heroicons/react/24/outline';
import Drawer from "@/controllers/Drawer";
import { TablePagination } from "@/components/holders/TablePagination";
import {showConfirmModal, hideModal} from "@/reducers/ModalPopup";    
import { rolesEdit, roleDelete } from "@/reducers/Roles";

export function RolesOverview({...props}) {
    let tableItems = (props?.data && props?.data?.roles) ? props.data.roles : [];
    const navi = useNavigate();        
    
    //const {items} = data;
    const [selectedData, setSelectedData] = useState(null);
const editRole = (item) => {
    
    navi("/roles/edit/"+item.key, {replace: true, state: { rolState: "value" }});
    //store.dispatch( rolesEdit(item.key));
    //to={"edit/"+item.key}
}

const removeHandler = (event, item) => {
    event.preventDefault();
    
    store.dispatch(showConfirmModal({item: item, action: confirmedRemoveHandler}));
    
    return false;
  }
const confirmedRemoveHandler = (props) => {
    store.dispatch(roleDelete(props.item.key));
    store.dispatch(hideModal());
}


  return (
    <>


    <div className="px-4 sm:px-6 lg:px-8">
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-base font-semibold leading-6 text-gray-900">Rollen en rechten</h1>
        </div>
      <div className="mt-3 sm:ml-4 sm:mt-0">
        <Link to={"add"} 
          type="button"
          className="inline-flex items-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
          Toevoegen
        </Link>
      </div>
        
      </div>
      <div className="mt-8 flow-root">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <table className="min-w-full divide-y divide-gray-300">
              <thead>
                <tr>
                  <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Naam
                  </th>
                  <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-0">
                    <span className="sr-only">Edit</span>
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {tableItems && tableItems.map((item) => (
                  <tr key={item.key}>
                    <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0">
                        <div className="flex gap-x-6">
                            {item.name}
                      </div>
                    </td>
                    <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-0 mr-5">
                                <Link 
                                onClick={(e) => {removeHandler(e, item);}}
                                className="rounded bg-white px-2 py-1 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 mr-5">
                        Verwijderen<span className="sr-only">, {item.name}</span>
                      </Link>
                    
                                <Link to={"edit/"+item.key}  className="rounded bg-white px-2 py-1 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 ">
                        Bewerken<span className="sr-only">, {item.name}</span>
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <TablePagination className="mt-2" data={props?.data}/>
          </div>
        </div>
      </div>
    </div>
          

    </>
      );
}
